import { type RouteObject } from 'react-router'

import {
  CHARTS_DETAIL_TRANSACTION_PATH,
  CHARTS_TRANSACTION_PATH,
  CHARTS_URL,
} from 'features/charts/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
// Charts v1 is dead — Container.tsx just redirects to v2; see its comment.
const chartsPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/charts/Container'))

export const chartsRoutes: RouteObject[] = [
  {
    path: CHARTS_URL,
    lazy: chartsPage(),
    handle: {
      sentryTransactionPath: CHARTS_TRANSACTION_PATH,
    },
  },
  {
    path: `${CHARTS_URL}/:dashboardId`,
    lazy: chartsPage(),
    handle: {
      sentryTransactionPath: CHARTS_DETAIL_TRANSACTION_PATH,
    },
  },
]
